<script setup>
import { useI18n } from "vue-i18n";
import { Modal } from "ant-design-vue";
import { ref } from "vue";
import CustomerSecurityAndSettingsEmailModifyForm from "@/views/profiles/items/form/security/CustomerSecurityAndSettingsEmailModifyForm.vue";
import CustomerSecurityAndSettingsChangePasswordForm from "@/views/profiles/items/form/security/CustomerSecurityAndSettingsChangePasswordForm.vue";

const { t } = useI18n();
const AModal = Modal;
const props = defineProps({
  equipmentType: {},
});
const emailEditModalOpenRef = ref(false);
const changePasswordModalOpenRef = ref(false);

function editEmail() {
  emailEditModalOpenRef.value = true;
}

function changePassword() {
  changePasswordModalOpenRef.value = true;
}
</script>

<template>
  <div class="row">
    <div class="col-10">
      <div class="font_weight font-24">Security and settings</div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 mg-b-10">
          Keep your account safe with a secure password and by signing out of
          devices you're not actively using.
        </div>
        <div>
          <button
            :style="{ width: equipmentType === 'iphone' ? '80%' : '40%' }"
            class="btn btn-secondary"
            @click="editEmail"
          >
            <div class="text-start">
              <div>Email</div>
              <div class="font-14">alva.liu@skwidetech.com</div>
            </div>
          </button>
        </div>
        <div class="mg-t-10">
          <button
            :style="{ width: equipmentType === 'iphone' ? '80%' : '40%' }"
            class="btn btn-secondary"
            @click="changePassword"
          >
            <div class="text-start">
              <div>Change Password</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  add/edit email-->
  <a-modal
    v-model:open="emailEditModalOpenRef"
    :cancel-button-props="{ style: { display: 'none' } }"
    :maskClosable="false"
    :ok-button-props="{ style: { display: 'none' } }"
    :width="equipmentType !== 'iphone' ? '40%' : '100%'"
    centered
    z-index="1111"
  >
    <CustomerSecurityAndSettingsEmailModifyForm />
  </a-modal>
  <!-- add/edit  email END-->

  <!-- change password-->
  <a-modal
    v-model:open="changePasswordModalOpenRef"
    :cancel-button-props="{ style: { display: 'none' } }"
    :maskClosable="false"
    :ok-button-props="{ style: { display: 'none' } }"
    :width="equipmentType !== 'iphone' ? '60%' : '100%'"
    centered
    z-index="22222"
  >
    <CustomerSecurityAndSettingsChangePasswordForm />
  </a-modal>
  <!-- change password END-->
</template>

<style scoped></style>
